import { configureStore } from '@reduxjs/toolkit';
import sessionStorage from 'redux-persist/lib/storage/session';
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from './reducers/index';

const persistConfig = {
  key: 'root',
  storage: sessionStorage,
  whitelist: [
    'app',
    'agencyAssessments',
    'agencyFindings',
    'agencyAgents',
    'agencySkills',
    'agencyMethods',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
